import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, PlusCircle, History, LogOut, Radio, Settings } from "lucide-react";
import NotificationBell from "@/components/NotificationBell";

export default function AppHeader() {
  const { user, logout } = useAuth();
  const settingsCtx = useSettings();
  const displayName = settingsCtx?.settings?.display_name || user?.display_name || user?.name || "Bettor";
  const nav = useNavigate();
  const loc = useLocation();
  const link = (to, label, Icon, testid) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-2 px-3 py-2 rounded-md text-xs uppercase tracking-widest font-semibold transition-colors ${
          active ? "bg-emerald-500/15 text-emerald-300" : "text-slate-400 hover:text-white hover:bg-white/5"
        }`}
      >
        <Icon className="h-4 w-4" /> {label}
      </Link>
    );
  };
  return (
    <header className="sticky top-0 z-40 bg-[#0A0D14]/85 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="brand-link">
          <img src="/bettrackr-logo.svg" alt="BetTrackr" className="h-8 w-8" />
          <span className="font-black uppercase tracking-tight text-white text-lg" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
            Bet<span className="text-emerald-400">Trackr</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {link("/dashboard", "Live", LayoutDashboard, "nav-dashboard-link")}
          {link("/add", "New Slip", PlusCircle, "nav-add-link")}
          {link("/history", "History", History, "nav-history-link")}
          {link("/settings", "Settings", Settings, "nav-settings-link")}
        </nav>
        <div className="flex items-center gap-3">
          <NotificationBell />
          {user?.picture && (
            <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-white/10" />
          )}
          <div className="hidden sm:block text-right">
            <div className="text-xs text-slate-400 uppercase tracking-wider">Signed in</div>
            <div data-testid="header-display-name" className="text-sm text-white truncate max-w-[140px]">{displayName}</div>
          </div>
          <Button data-testid="logout-button" variant="ghost" size="icon" onClick={async () => { await logout(); nav("/login"); }}>
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
